import Button from 'components/button';
import {MODAL} from 'features/modal-notch/constants';
import ConfigureManDaysModal from '../containers/configure-man-days-modal';

export default {
  [MODAL.CONFIG_MAN_DAYS_MODAL]: ConfigureManDaysModal, // REPLACE WITH YOUR ACTUAL MODAL COMPONENT
};
